import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { trackEvent } from '@services/tracking';
import { clsx } from 'clsx';

export const WhatsNewSection = () => (
  <div className="flex flex-col md:flex-row gap-8">
    <div className="flex flex-col gap-4 py-4 px-6 bg-white rounded-[20px] flex-1">
      <div className="flex justify-between items-center">
        <Typography variant="headline" size="medium">
          What’s new
        </Typography>
        <a
          className="text-black"
          href="https://bird-hexahedron-8fz2.squarespace.com"
          target="_blank"
          rel="noreferrer"
          onClick={() => trackEvent({ type: "What's New Section Tapped" })}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </div>
      <Typography variant="body" size="large">
        We've been hard at work to bring you new features, enhancements, and
        improvements. Check out what's fresh and exciting in our product
      </Typography>
    </div>
    <div className="flex flex-col gap-4 relative bg-[url('/static/images/home/whats-new-bg.png')] bg-no-repeat bg-cover px-[31px] py-[27px] rounded-[10px] flex-1">
      <Typography variant="title" className="text-white">
        Give us feedback & vote on your favourite features
      </Typography>
      <a
        className="w-max mt-2"
        href="https://playbookapp.typeform.com/to/hhCBrx4h"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent({ type: 'Share Feedback Tapped' })}
      >
        <div
          className={clsx(
            'flex gap-2 px-4 py-2 rounded-[10px]',
            sprinkles({ bg: 'W-100', color: 'B-100' }),
          )}
        >
          <Typography>Share feedback</Typography>
        </div>
      </a>
    </div>
  </div>
);
